import styled from "styled-components";
import ContributionIcon from './contribution-icon.svg';
import CheckIcon from '../../assets/check-icon.svg';

export const Container = styled.div`
	display: flex;
	width: 100%;
	max-width: 880px;
	margin: 75px auto 0;
	justify-content: space-between;
`;

export const Left = styled.div`
	flex: 1;
`;

export const Right = styled.div`
	display: flex;
	flex-flow: column;
	align-items: center;
	align-self: flex-end;
	margin-top: 0;
	margin-bottom: 30px;
`;

export const Title = styled.h2`
	line-height: 1.15;
	font-size: 2.6rem;
	color: #1d1d1d;
`;

export const Paragraph = styled.p`
	max-width: 380px;
	font-size: 0.95rem;
	color: #333;
`;

export const CheckboxLabel = styled.label`
	font-size: 0.8rem;

	input {
		outline: 0;
		box-shadow: none;
		border: 2px solid #333;
		&:checked {
			&:before {
				content: url(${CheckIcon});
				margin-top: 0;
			}
		}
	}
`;

export const WhereTitle = styled.h3`
	font-size: 1.2rem;
	text-align: center;
	color: #333;
`;

interface ButtonProps {
	variant: 'contribution' | 'paywall'
}

export const Button = styled.button<ButtonProps>`
	cursor: pointer;
	border: 0;
	font-size: 0.8rem;
	font-weight: 500;
	background-color: transparent;
	.icon {
		display: block;
		width: 170px;
		height: 150px;
		margin-bottom: 5px;
		border: 2px solid #333;
		background: url(${ContributionIcon});
		background-size: 45%;
		background-repeat: no-repeat;
		background-position: center center;
	}
`;
